<template>
<div>

  <div class="content content-boxed">

      <div class="row">
        <div class="col-xs-12">
          <div v-if="displayTab" class="block block-themed block-bordered">

            <ul class="nav nav-tabs nav-tabs-alt nav-justified" data-toggle="tabs">

              <li :class="{'active': tabMenuSelector[0]==true}"  @click="toggleTabMenuSelector(0)">
                  <a ><i class="fa fa-industry"></i> {{homeTabMenuOrganization[actualLanguage] }}</a>
              </li>

              <li :class="{'active': tabMenuSelector[1]==true}"  @click="toggleTabMenuSelector(1)">
                  <a ><i class="fa fa-file-text-o"></i> {{homeTabMenuPayment[actualLanguage] }}</a>
              </li>


            </ul>

            <div class="block-content tab-content">

              <!-- =========================================================================== -->
              <!-- Ajout/modification  d'organisation -->
              <!-- =========================================================================== -->
              <div :class="{'tab-pane': true, 'active': tabMenuSelector[0]==true}" >
                <div class="col-xs-12">
                  <integrator-sub-organization v-bind:organization="organization"></integrator-sub-organization>
                </div>
              </div>

              <!-- =========================================================================== -->
              <!-- Visionnement historique de transaction clients -->
              <!-- =========================================================================== -->
              <div :class="{'tab-pane': true, 'active': tabMenuSelector[1]==true}" >
                <div class="col-xs-12 push">
                  <integrator-customer-payment-history v-bind:organization="organization"></integrator-customer-payment-history>
                </div>
                
                <div class="col-xs-12 push">
                  <integrator-commissions-reports v-bind:organization="organization"></integrator-commissions-reports>
                </div>

              </div>


            </div>


          </div>
        </div>
      </div>



  </div>
</div>
</template>


<script>

import Spinner from '@/components/Spinner'

import {mapState, mapActions, mapGetters} from 'vuex'
import IntegratorSubOrganization from './IntegratorSubOrganization'
import IntegratorCustomerPaymentHistory from './IntegratorCustomerPaymentHistory'
import IntegratorCommissionsReports from './IntegratorCommissionsReports'

export default {
  name: 'GroupIndex',
  props: ['organization'],
  data() {
    return {
      flagDisplayBanner : 0,
      profileIsSaving : false,
      actualLanguage : "FR",
      labelTitleSection: {FR: 'Titre bannière', EN: 'Banner Title'},
      labelTitleBanner: {FR: 'Titre bannière', EN: 'Banner Title'},

      displayTab : false,
      test : 1,
      tabMenuSelector : [true, false, false, false],
      homeTabMenuOrganization: {FR: 'Organisations clients', EN: 'Organizations customers'},
      homeTabMenuPayment: {FR: 'Historique de commissions', EN: 'Commissions history'},
      homeTabMenuRoyalties: {FR: 'Rapport commissions', EN: 'Commissions report'},

    }
  },
  components: {
    Spinner,
    IntegratorSubOrganization,
    IntegratorCustomerPaymentHistory,
    IntegratorCommissionsReports
  },
  computed: {
    ...mapState('sessionStore', ['userEmail','profileData']),
  },

  methods: {
    ...mapActions('overlayStore', ['showModal']),

      toggleTabMenuSelector(index){
          this.displayTab = false
          for(var n=0;n<this.tabMenuSelector.length;n++){this.tabMenuSelector[n]=false}
          this.tabMenuSelector[index]=true
          //Comprend pas mais besoin de cette ligne pour que ca fonctionne !!
          this.test = index
          this.displayTab = true
      },



    saveMyProfile(){
        var requestData = {'postAction':'UpdateProfile',
                          'profileData':this.profileData}
        this.profileIsSaving = true
        this.$store.dispatch('sessionStore/postProfile', requestData)
            .then((response) => {
            this.profileIsSaving = false
            if(response.data.Code=='OK'){
                window.alert(this.messageProfileSaved[this.actualLanguage])
                }
                else{
                  window.alert(response.data.PromptMessage[this.actualLanguage])
                  }
            })
    },





    returnToMyServicePlan(){
      this.planTransactionData.transactionStatusCode = '000'
      this.flagDisplayPlan = 0
      window.scrollTo(0, 0)
    },



    },

  mounted() {
    //this.getDeviceData()
    //window.location.reload()
    this.toggleTabMenuSelector(0)


    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}
  }
}
</script>





// WEBPACK FOOTER //
// IntegratorTabMenu.vue?21e0fee8